import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[color:var(--bg)] border-t border-white/10"
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-10 lg:px-14 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <p className="font-mono-mc mb-6">A creative membership</p>
            <h3 className="font-display-tight text-4xl md:text-6xl lg:text-7xl ink leading-[0.95]">
              We're Midcreatives.<span className="ink-muted">.</span>
            </h3>
            <Link
              to="/apply"
              data-testid="footer-apply-cta"
              className="btn-lime mt-8"
            >
              Get Membership <span className="arrow-slide">→</span>
            </Link>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono-mc mb-4">Explore</p>
            <ul className="space-y-3">
              {[
                ["/services", "Services"],
                ["/membership", "Membership"],
                ["/leaders", "Leaders"],
                ["/events", "Events"],
                ["/about", "About"],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="ink-muted hover:text-white transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono-mc mb-4">For Members</p>
            <ul className="space-y-3 ink-muted">
              <li>Member Library</li>
              <li>Community</li>
              <li>Annual Summit</li>
              <li>Roundtables</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono-mc mb-4">Contact</p>
            <p className="ink-muted">hello@midcreatives.com</p>
            <p className="ink-dim mt-1">Global · Remote-first</p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-mono-mc">© {new Date().getFullYear()} Midcreatives</p>
          <p className="font-mono-mc">Annual only · By application · Limited seats</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
